import { Injectable } from '@angular/core';

import { ProtectedResources } from '@app/shared';
import { ApplicationConfiguration } from '@core/configuration';

@Injectable({
    providedIn: 'root'
})
export class ProtectedResourceService {
    constructor(private applicationConfig: ApplicationConfiguration) { }

    public getProtectedResources(): ProtectedResources {
        return {
            applicationApi: {
                endpoint: `${this.applicationConfig.applicationUri}`,
                scopes: {
                    read: [`https://${this.applicationConfig.azureB2c.domain}/${this.applicationConfig.appName}/api`],
                    write: [`https://${this.applicationConfig.azureB2c.domain}/${this.applicationConfig.appName}/api`]
                }
            }
        };
    }
}